import React from "react";
import Modal from "react-modal";
import find from "lodash/find";
import { Button } from "../../common/Button/Button";
import { ControlledInput } from "../../common/Input/Input";
import ModalContent from "../../common/Modal/ModalContent";
import ModalHeader from "../../common/Modal/ModalHeader";
import Select from "../../common/Select/Select";
import { useEffect } from "react";
import Spinner from "../../common/Spinner/Spinner";
import { getUser } from "../../utils/localStorage";
import Checkbox from "../../common/Checkbox/Checkbox";

Modal.setAppElement("#root");

export default function CreateUserModal({ userModalData, ...props }) {
	const getSelectedRoles = (defaultRole = null) => {
		console.log("userModalData", userModalData);
		const { role: roles } = userModalData;
		const { roleOptions } = props;
		let selectedRole = [];

		if (defaultRole) {
			selectedRole = props.roleOptions.filter(
				(option) => option.label === defaultRole
			);
			if (selectedRole.length && props.onlyChangeOnce) {
				props.onInputChange("role", [selectedRole[0]], true);
			}
		}
		if (roles) {
			const selectedRoles = roles.map((role) => {
				let found = null;
				if (Object.keys(role).length) {
					found = find(roleOptions, { value: role.value });
				} else {
					found = find(roleOptions, { value: role });
				}
				return found;
			});
			return selectedRoles;
		}
		if (selectedRole.length) {
			return [selectedRole[0]];
		} else {
			return [];
		}
	};
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<ModalHeader
					title={`${
						props.isEditUserModal ? "Edit User" : "Create User"
					}`}
					toggleModal={props.toggleModal}
				/>
				<div
					className={`container modal-body ${
						props.isLoading && "set-opacity"
					}`}
				>
					<div className="row">
						<div className="col-auto text-help">
							Please provide user details.
						</div>
					</div>
					<div className="row mt30 align-items-center">
						<div className="col-md-4 col-lg-4">
							<ControlledInput
								name="first_name"
								label="First Name"
								value={userModalData.first_name || ""}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
						<div className="col-md-4 col-lg-4">
							<ControlledInput
								name="last_name"
								label="Last Name"
								value={userModalData.last_name || ""}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
						<div className="col-md-4 col-lg-4">
							<ControlledInput
								name="email"
								label="Email"
								disabled={props.isEditUserModal}
								value={userModalData.email || ""}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
								required
							/>
						</div>
					</div>
					<div className="row mt5 align-items-center">
						<div className="col-md-6 col-lg-6">
							<Select
								label="Role"
								value={getSelectedRoles()	}
								name="role"
								options={props.roleOptions}
								isMulti
								onChange={(value) =>
									props.onInputChange("role", value)
								}
								required
							/>
						</div>
						<div className="col-md-4 col-lg-4" style={{paddingTop:"30px"}}>
						<span style={{float:"left"}}>Facilitator Status </span>
							<Checkbox
								id="unassigned-sr"
								name="facilitator_status"
								checked={userModalData.facilitator_status}
								onChange={({ target: { name, value } }) =>{
									if(userModalData.facilitator_status)
									{
										props.onInputChange(name, false)
									}
									else{
										props.onInputChange(name, true)
									}									
								}
								}
							/>
						</div>
					</div>
					<div className="row align-items-center"></div>
					{props.error ? (
						<div className="form-error">{props.error}</div>
					) : null}
					<div className="row mt30 align-items-center">
						<div className="col-auto">
							<Button
								isSubmitting={props.isSubmitting}
								onClick={props.onSaveUser}
							>
								Save User
							</Button>
						</div>
						<div
							className="col-auto cursor-pointer"
							onClick={props.toggleModal}
						>
							Cancel
						</div>
						<div className="ml-auto col-auto">
							<Button
								danger
								onClick={() => {
									userModalData.out_of_office
										? props.onInOffice()
										: props.onOutOfOffice();
								}}
								className={`${
									props.isEditUserModal ? "false" : "disabled"
								} ${
									userModalData.is_active === false
										? "disable"
										: ""
								}`}
							>
								{userModalData.out_of_office
									? "Mark in office"
									: "Mark out of office"}
							</Button>
						</div>
						<div className="ml-auto col-auto">
							<Button
								danger
								onClick={() => {
									userModalData.is_active
										? props.onDeactivateUser()
										: props.onReactivateUser();
								}}
								className={`${
									props.isEditUserModal ? "false" : "disabled"
								} ${
									getUser().email === userModalData.email
										? "disable"
										: ""
								}`}
							>
								{userModalData.is_active
									? "Deactivate User"
									: "Activate User"}
							</Button>
						</div>
					</div>
					{props.isLoading && <Spinner className="top" />}
				</div>
			</ModalContent>
		</Modal>
	);
}
